import React, { useEffect, useState } from "react";
import Movie from "./components/Movie";
import "./App.css";
import Body from "./components/Body";
import Footer from "./components/Footer";



function App() {
 

  return (
    <>
      <Body />
      <Footer/>
    </>
  );
  
}

export default App;
